// =====================================================================
// PatientNew (PME Sprint 1 / S50) — pagina /prontuario/novo.
// Cadastro de paciente: renderiza <PatientForm mode="create"> e faz POST.
// =====================================================================
import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import { Button } from "@material-ui/core";

import MainContainer from "../../components/MainContainer";
import MainHeader from "../../components/MainHeader";
import Title from "../../components/Title";
import MainHeaderButtonsWrapper from "../../components/MainHeaderButtonsWrapper";

import PatientForm from "./PatientForm";
import { createPatient, patientErrorMessage } from "../../services/patientService";

const PatientNew = () => {
  const history = useHistory();
  const [saving, setSaving] = useState(false);

  const handleSave = async (payload) => {
    setSaving(true);
    try {
      const patient = await createPatient(payload);
      toast.success("Paciente cadastrado com sucesso.");
      if (patient && patient.id) {
        history.push(`/prontuario/paciente/${patient.id}`);
      } else {
        history.push("/prontuario");
      }
    } catch (err) {
      toast.error(patientErrorMessage(err));
    } finally {
      setSaving(false);
    }
  };

  return (
    <MainContainer>
      <MainHeader>
        <Title>Novo Paciente</Title>
        <MainHeaderButtonsWrapper>
          <Button onClick={() => history.push("/prontuario")} disabled={saving}>
            Voltar
          </Button>
        </MainHeaderButtonsWrapper>
      </MainHeader>

      <div style={{ flex: 1, overflowY: "auto", minHeight: 0, paddingTop: 8 }}>
        <PatientForm
          mode="create"
          saving={saving}
          onSave={handleSave}
          onCancel={() => history.push("/prontuario")}
        />
      </div>
    </MainContainer>
  );
};

export default PatientNew;
